import { ImgKakaoPay, ImgNaverPay } from '../../static/images';

// 결제수단 목록 — 옛 사이트의 온라인 결제 선택지 그대로. 지금은 사용할 수 없고(접수만 가능) 흐리게 보여 주기만 한다.
// 온라인 결제를 다시 켜면(WEB_PAYMENT_ENABLED) 같은 목록을 선택 UI로 되살린다.
export const PAY_METHODS = [
  { key: 'Card', label: '신용/체크카드' },
  { key: 'Account', label: '계좌이체' },
  { key: 'CorporateAfter', label: '법인후불' },
  { key: 'NaverPay', label: '네이버페이', image: ImgNaverPay, imageWidth: 72 },
  { key: 'KakaoPay', label: '카카오페이', image: ImgKakaoPay, imageWidth: 56 },
];

export const UNAVAILABLE_TEXT = '현재 사용 불가 · 접수는 가능합니다!';
